import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { infoJourneyList } from "../../../redux/actions/journey";
import Button from "../../global/Button/Button";
import CardFetching from "../../global/CardFetching/CardFetching";
import CreatePlaylist from "../../global/CreatePlaylist/CreatePlaylist";
import GreyPopUp from "../../global/GreyPopUp/GreyPopUp";
import EditPlaylistModal from "./EditPlaylistModal/EditPlaylistModal";
import "./PlaylistMobile.scss";

const PlaylistMobile = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [createPlaylist, setCreatePlaylist] = useState(false);
  const [editPlaylistModal, setEditPlaylistModal] = useState(false);
  const journeyList = useSelector(state => state.journey?.journeyList?.items);
  const journeyIsFetching = useSelector(state => state.journey?.isFetching);
  const [idItem, setIdItem] = useState("");
  const [deletePopUpOpen, setDeletePopUpOpen] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState("");
  const [createPlaylistPopUp, setCreatePlaylistPopUp] = useState(false);
  const [createMessage, setCreateMessage] = useState("");

  useEffect(() => {
    dispatch(infoJourneyList())
  }, [dispatch])

  return (
    <section className="PlaylistMobile">
      <div className="playlist-mobile-container">
        <div className="playlist-add-container">
          <Button children="Nova playlist" primaryColor="#CFEC59" onClick={() => setCreatePlaylist(true)}/>
        </div>
        <div className="playlist-mobile-list">
          {journeyIsFetching ? <div className="journeylist-fetching"><CardFetching amount={5}/></div> :
          journeyList && journeyList.map((item, key) => {
            return <><div key={key}>
              <p onClick={() => history.push(`/colecao/${item && item?.id}`)}
              >{item.name}</p>
              <button onClick={() => {
                setEditPlaylistModal(true)
                setIdItem(item?.id)
              }}/>
            </div>
            </>
          })}
        </div>
      </div>
      {<CreatePlaylist setCreateMessage={setCreateMessage} setCreatePlaylistPopUp={setCreatePlaylistPopUp}
                       setCreatePlaylist={setCreatePlaylist} createPlaylist={createPlaylist}/>}
      {<EditPlaylistModal id={idItem}
                          setEditPlaylistModal={setEditPlaylistModal} editPlaylistModal={editPlaylistModal}
                          setDeleteMessage={setDeleteMessage} setDeletePopUpOpen={setDeletePopUpOpen}/>}
      {deletePopUpOpen && <GreyPopUp text={deleteMessage} onClick={() => setDeletePopUpOpen(false)}/>}
      {createPlaylistPopUp && <GreyPopUp text={createMessage} onClick={() => setCreatePlaylistPopUp(false)}/>}
    </section>
  );
};

export default PlaylistMobile;
